/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Role_PhysioInputs */

const en_coaches_page_role_physio = /** @type {(inputs: Coaches_Page_Role_PhysioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physio`)
};

const pl_coaches_page_role_physio = /** @type {(inputs: Coaches_Page_Role_PhysioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fizjoterapeuta`)
};

/**
* | output |
* | --- |
* | "Physio" |
*
* @param {Coaches_Page_Role_PhysioInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_role_physio = /** @type {((inputs?: Coaches_Page_Role_PhysioInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Role_PhysioInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_role_physio(inputs)
	return en_coaches_page_role_physio(inputs)
});